import React from "react";
import AboutUs from "../../../components/AboutUs/AboutUs";

const OurMissionSection = () => {
  return (
    <div>
      <AboutUs />
    </div>
  );
};

export default OurMissionSection;
